
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","stroke-linejoin":"round","d":"M6.774 33.63V10h34.37v23.63"}}),_c('path',{attrs:{"fill":"#F9CE62","d":"M21.896 29.935a7.653 7.653 0 1 0-10.487 0 5.64 5.64 0 0 1 10.487 0"}}),_c('path',{attrs:{"stroke":"#234652","d":"M17.252 15.407a7.153 7.153 0 0 1 5.386 11.86 6.14 6.14 0 0 0-5.386-3.193 6.14 6.14 0 0 0-5.385 3.193 7.153 7.153 0 0 1 5.386-11.86Z"}}),_c('circle',{attrs:{"cx":"17.253","cy":"20.143","r":"2.722","stroke":"#234652"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M26.92 18.667h10.74M26.915 18.667h10.74"}}),_c('path',{attrs:{"stroke":"#F9CE62","stroke-linecap":"round","stroke-linejoin":"round","d":"M26.915 19.867h12"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M26.915 21.867h8.592"}}),_c('path',{attrs:{"stroke":"#F9CE62","stroke-linecap":"round","stroke-linejoin":"round","d":"M26.915 23.067h10.2"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M26.915 25.066h11.854"}}),_c('path',{attrs:{"stroke":"#F9CE62","stroke-linecap":"round","stroke-linejoin":"round","d":"M26.915 26.267h9.255"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linejoin":"round","d":"M45.397 34.704H2.522S3.02 39 5.7 39h36.519c2.68 0 3.178-4.296 3.178-4.296Z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M17.515 36.852h12.889"}})])
          )
        }
      }
    